app.controller("EditProgramPropertiesController", [
    "$scope", "StaticData", "ProgramService", "Lecturer", "$uibModalInstance", "params", "InfoModal", "usSpinnerService", "$http",
    function ($scope, StaticData, ProgramService, Lecturer, $uibModalInstance, params, InfoModal, usSpinnerService, $http) {
        $scope.heads = [];
        $scope.faculties = [];
        $scope.levels = [];
        $scope.name = "";
        $scope.code = "";
        $scope.faculty = "";
        $scope.speciality = "";
        $scope.level = "";
        $scope.credits = 240;
        $scope.semesters = 8;

        ProgramService.fetchOne(params.programId).then(function (program) {
            $scope.program = program;
            if ($scope.program && $scope.program.heads) {
                loadHeads($scope.program.heads);
            }
            if (!$scope.program.attachment) {
                $scope.program.attachment = {}
            }
        });

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = faculties;
        });

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = levels;
        });

        StaticData.getItemsByKey("lecturer_ranks").then(function (ranks) {
            $scope.ranks = [{ name: "თანამდებობა" }].concat(ranks);
            $scope.ranksMap = _.keyBy($scope.ranks, '_id');
        });

        function loadHeads() {
            $scope.program.heads.forEach(function (headId) {
                Lecturer.fetchOne(headId).then(function (data) {
                    $scope.heads.push(data);
                });
            })
        }

        $scope.getLecturers = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Lecturer.list({ query: query }).then(function (data) {
                return data.docs;
            });
        };

        $scope.$watch('program.choosenHead', function (head) {
            if (head && head._id) {
                $scope.heads.push(head);
                $scope.program.choosenHead = null;

            }
        }, true);

        $scope.remove_head = function (id) {
            var el_index = _.findIndex($scope.heads, function (head) {
                return id === head._id;
            });
            $scope.heads.splice(el_index, 1);
        };

        $scope.update = function () {
            if (!$scope.editProgramForm.$valid) {
                InfoModal.show({ message: "შეავსეთ ყველა ველი სწორად", title: "შეცდომა" });
                return;
            }
            $scope.program.heads = $scope.heads.map(h => h._id);
            ProgramService.update($scope.program).then(function () {
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.uploadAttachment = function (type, files) {
            usSpinnerService.spin("root");
            $scope.file = files[0];
            var fd = new FormData();
            if ($scope.file && $scope.file.name) {
                fd.append('file', $scope.file, $scope.file.name);
                $http.post('/documents/attachments', fd, {
                    headers: { 'Content-Type': undefined }
                }).then(function (response) {

                    $scope.program.attachment = response.data;
                    usSpinnerService.stop("root");
                })
            }
        };

        $scope.removeFile = function () {
            $scope.file = null;
            $scope.program.attachment = null;
        }

        $scope.download = function () {
            window.open($scope.program.attachment.location);
        }


    }
]);
